export default "__VITE_ASSET__mm34bme___"